export class AdminProfileResource {
    errorCode: number;
    errorMessage: string;
    profile: string;
}
